import {Outlet} from "react-router-dom";
import {Toaster} from "react-hot-toast";
import React, {useEffect} from "react";
import Loading from "../components/atoms/Loading";
import Sidebar from "../components/main/Sidebar";
import {useStateContext} from "../context/AdminDashboard/MainContext";

const MainRoute = () => {
    const { isPageLoaded, getSidebar } = useStateContext();
    useEffect(() => {
        getSidebar();

    }, []);

    if (!isPageLoaded) {
        return <Loading height={"h-100"} />;
    }
    return (<div className="App bg-bg min-h-100 ">
        <Sidebar/>
        <div className="mr-56.9 " id={"parentElement"}>
            <Outlet/>
        </div>
        <Toaster/>
    </div>)
}
export default MainRoute